var $b09198915a38946f$exports = {};
$b09198915a38946f$exports = {
  "Clear search": "Cancella ricerca"
};
export { $b09198915a38946f$exports as default };